export const getLocation = (href) => {
  var anchor = document.createElement('a');
  anchor.href = href;
  return anchor;
};
